import React, { Component } from "react";
import clsx from "clsx";
import {
  makeStyles,
  withStyles,
  useTheme,
  styled,
} from "@material-ui/core/styles";
import Save from "../../../../assets/img/svg/save.svg";
import Cancel from "../../../../assets/img/svg/cancel.svg";
import Delete from "../../../../assets/img/svg/delete.svg";
import download from "../../../../assets/img/svg/DownloadIcon.svg";
import { Tabs, Tab, AppBar, Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import EditDWPR_Detail from "./EditDWPR-Detail";
import EditDWPR_Historylog from "./EditDWPR-Historylog";
import del from "../../../../assets/img/svg/Del.svg";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import moment from "moment";
import Autocomplete from "react-autocomplete";
import {
  TextField,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import {
  putdwprdocinfo,
  deletemulitipbddocs,
} from "../../../../actions/DWPRAction";
import {
  getprojectdwprdocinfo,
  dwprlookupactivities,
  deletemulitidwprdocs,
  deletedwprdocs,
  gethistorylogdwprdocinfo,
  filedeletedwpr,
  dwprlookupdescription,
} from "../../../../actions/DWPRAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import deactive from "../../../../assets/img/svg/deactive.svg";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import InnerImageZoom from "react-inner-image-zoom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

class EditDWPR extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      ProjectId: 0,
      Docs: [],
      isView: false,
      DeleteData: [],
      isMobile: false,
      Id: 0,
      DelIndex: 0,
      cancel: false,
      filename: "",
      awsname: "",
      Error: {
        ActivityError: false,
        StartDateError: false,
      },
      value: 0,
      addData: {
        Id: 0,
        ProjectId: 0,
        Description: "",
        Activity: "",
        StartDate: "",
        Comments: "",
        ModifiedBy: "",
      },
      index: 0,
      ViewDate: "",
      ViewData: [],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    window.location.pathname == "/dailyworkprogressreport/edit"
      ? this.setState({ isView: false })
      : this.setState({ isView: true });
    this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
    this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
    this.state.addData.Id = parseInt(localStorage.getItem("DWPREditId"));
    this.state.DeleteData.push(parseInt(localStorage.getItem("DWPREditId")));
    this.state.ProjectId = localStorage.getItem("DashId");
    this.state.UserRole = localStorage.getItem("UserRoles");
    this.setState({});
    this.props.dispatch(getlookupdocinfo("DailyProgress"));
    this.props.dispatch(getSettingsFormat(this.state.ProjectId));
    window.location.pathname == "/dailyworkprogressreport/edit"
      ? this.setState({ isView: false })
      : this.setState({ isView: true });
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
    if (window.location.pathname == "/dailyworkprogressreport/view") {
      this.state.ViewDate = localStorage.getItem("DWPRViewId");
      this.setState({});
      this.ViewPage(this.state.ViewDate);
    } else {
      this.geteditdwprdocinfo(this.state.addData.Id);
    }
  }

  ViewPage = (id) => {
    let apiUrl = API.DWPR_LISTVIEW + "/id?id=" + id;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.state.ViewData = response.data;
          this.setState({});
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    $("#DAILY1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#DailyWork1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#DailyWork").addClass("d-none");
    $("#DailyWork").removeClass("d-block");
    $("#DWPL").removeClass("active-color");
    $("#DWPT").removeClass("fw-bolder");
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
    if (this.state.value == 0) {
      this.props.dispatch(gethistorylogdwprdocinfo(this.state.ProjectId));
    }
    if (this.state.value == 1) {
      // this.geteditdwprdocinfo(this.state.addData.Id)
    }
  };

  DeleteItemfile = () => {
    let tempData = [];
    this.state.Docs.map((i, index) => {
      if (this.state.DelIndex == index) {
        if (
          i.AwsUniqueFileName == this.state.awsname &&
          this.state.awsname != undefined
        ) {
          this.props.dispatch(
            filedeletedwpr(this.state.addData.Id, this.state.awsname)
          );
        }
      }
      if (this.state.DelIndex != index) {
        tempData.push(i);
      }
    });
    this.state.Docs = tempData;
    this.setState({});
    window.$("#deletepopup1").modal("hide");
  };

  OpenPopup = (filename, awsname, id, index) => {
    this.state.filename = filename;
    this.state.awsname = awsname;
    // this.state.Id = id;
    this.state.DelIndex = index;
    this.setState({});
    window.$("#deletepopup1").modal("show");
  };
  // openView = (url, name) => {
  //     this.state.fileUrl = url;
  //     this.state.fileName = name;
  //     this.setState({})
  //     window.$('#viewscreen').modal('show')
  // }
  openView = (url, name, ind) => {
    this.state.fileUrl = url;
    this.state.fileName = name;
    this.state.index = ind;
    this.setState({});
    window.$("#viewscreen").modal("show");
  };
  openView1 = (url, name, ind) => {
    this.state.fileUrl = url;
    this.state.fileName = name;
    this.state.index = ind;
    this.setState({});
    window.$("#viewscreen1").modal("show");
  };
  geteditdwprdocinfo = (id) => {
    let apiUrl = API.DWPR_LISTVIEW + "/id?id=" + id;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.addData.Id = response.data.Id;
          this.state.addData.Description = response.data.Description;
          this.state.addData.Activity = response.data?.Activity;
          this.state.addData.StartDate = response.data?.StartDate;
          this.state.addData.Comments = response.data?.Comments;
          if (response.data?.Photos.length > 0) {
            // response.data?.Photos.map((i) => {
            //     i.FileName = i.FileName;
            //     i.ObjectKey = i.ObjectKey;
            //     i.AwsFolderName = i.AwsFolderName;
            //     i.AwsUniqueFileName = i.AwsUniqueFileName;
            //     i.FileExtention = i.FileExtention;
            //     i.FileUrl = i.FileUrl;
            //     i.check = false;
            // })
            this.state.Docs = response.data?.Photos;
          }
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  sidebar = () => {
    if (this.state.cancel === true) {
      window.$("#cancelpopup1").modal("show");
    } else {
      this.props.navigate("/sidebar");
    }
  };
  SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup1").modal("hide");
    this.props.navigate("/sidebar");
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  resize1 = () => {
    $("#DAILY1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#DailyWork1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#DailyWork").removeClass("d-none");
    $("#DailyWork").addClass("d-block");
    $("#DWPL").addClass("active-color");
    $("#DWPT").addClass("fw-bolder");
  };

  DeleteItem = () => {
    this.deletedwprdocs(this.state.DeleteData, this.state.UserRole);
  };

  deletedwprdocs = (data, modify) => {
    let apiUrl = API.DWPR_LISTVIEW + "/id?ids=" + data + "&modify=" + modify;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "DELETE",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.props.navigate("/dailyworkprogressreport");
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  EditCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup").modal("hide");
    this.props.navigate("/dailyworkprogressreport");
  };
  ViewCancel = () => {
    this.props.navigate("/dailyworkprogressreport");
  };
  EditSave = () => {
    if (this.state.addData.Activity.trim() == "") {
      this.state.Error.ActivityError = true;
      this.state.addData.Activity = this.state.addData.Activity.trim();
      this.setState({});
    } else {
      this.state.Error.ActivityError = false;
      this.state.addData.Activity = this.state.addData.Activity.trim();
      this.setState({});
    }

    if (this.state.addData.StartDate == "") {
      this.state.Error.StartDateError = true;
      this.setState({});
    } else {
      this.state.Error.StartDateError = false;
      this.setState({});
    }
    if (
      this.state.addData.Activity != "" &&
      this.state.addData.StartDate != ""
    ) {
      this.props.dispatch({ type: "CANCEL", data: false });
      let formData = new FormData();
      let array = [];
      Array.from(this.state.Docs).forEach(async (a) => {
        if (a.AwsUniqueFileName == undefined) {
          formData.append("photo", a.fdata);
          array.push(a);
        }
      });
      if (this.state.addData.Description === "") {
        this.state.addData.Description = "";
        this.setState({});
      } else {
        this.state.addData.Description = this.state.addData.Description.trim();
        this.setState({});
      }
      if (this.state.addData.Comments != null) {
        this.state.addData.Comments = this.state.addData.Comments.trim();
        this.setState({});
      }
      this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
      this.setState({});
      this.putdwprdocinfo(
        this.state.addData,
        formData,
        this.state.addData.Id,
        array
      );
    }
  };
  putdwprdocinfo = (data, formData, id, array) => {
    let apiUrl = API.DWPR_LISTVIEW + "/" + id;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (array.length > 0) {
            this.adduploaddwprdocinfo(formData, id);
          } else {
            this.props.dispatch({ type: "SHOW_LOADER", data: false });
            this.props.navigate("/dailyworkprogressreport");
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
  adduploaddwprdocinfo = (data, id) => {
    let apiUrl = API.DWPR_LISTVIEW + "/" + id;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });

        if (response?.status === 200) {
          this.props.navigate("/dailyworkprogressreport");
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });

        if (error?.response?.status === 401) {
        }
      });
  };

  EditCancel1 = () => {
    if (this.state.value == 1) {
      this.state.value = 0;
      this.setState({});
      this.geteditdwprdocinfo(this.state.addData.Id);
    } else {
      if (this.state.cancel == true) {
        window.$("#cancelpopup").modal("show");
      } else {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dailyworkprogressreport");
      }
    }
  };

  handleInputChange = (e, str) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    if (str == "Comments") {
      if (e.target.value.length - 1 < 1000) {
        this.state.addData[str] = e.target.value;
        this.setState({});
      }
    } else if (str == "Description") {
      if (e.target.value.length - 1 < 500) {
        this.state.addData[str] = e.target.value;
        this.setState({});
      }
    } else {
      this.state.addData[str] = e.target.value;
      this.setState({});
    }
    this.setState({});
    this.props.dispatch({ type: "SHARE_DWPRFILES", data: this.state.addData });
  };

  AttachFiles = (e) => {
    this.inputFile.current.click();
  };

  UploadFile = (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    Array.from(e.target.files).forEach(async (a) => {
      let upload = {
        FileName: a.name,
        FileSize: a.size,
        check: false,
        fdata: a,
        FileUrl: await this.toBase64(a),
      };
      this.state.Docs.push(upload);
      this.setState({ Docs: this.state.Docs });
    });
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  renderProjectNames = (state, val) => {
    return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  };

  handleProjectNameSearchChange = (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.addData.Activity = e.target.value;
    this.setState({});
  };

  handleProjectNameSelectChange = (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.addData.Activity = e;
    this.setState({});
  };
  nextView = (ind) => {
    if (
      this.state.isView
        ? this.state.ViewData.Photos.length === ind
        : this.state.Docs.length === ind
    ) {
      this.setState({
        index: 0,
      });
    } else {
      this.setState({
        index: ind,
      });
    }
  };
  preView = (ind) => {
    if (ind === -1) {
      this.setState({
        index: this.state.isView
          ? this.state.ViewData.Photos.length - 1
          : this.state.Docs.length - 1,
      });
    } else {
      this.setState({
        index: ind,
      });
    }
  };
  setIndex = (ind) => {
    this.setState({
      index: ind,
    });
  };
  render() {
    let { classes, menuToggle } = this.props;

    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={() => this.sidebar()}>
                    <ListItemText
                      id={"DAILY" + "1"}
                      className="textNaviIcon"
                      primary="Daily Tasks"
                    />
                    <NavigateNextIcon
                      id="DAILY"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5">
                <h4>
                  {this.state.isView
                    ? "Daily Work Progress"
                    : " Edit Work Progress"}
                </h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -95,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  {this.state.value == 1 ? (
                    <>
                      <td width="5%" className="border-right">
                        <i
                          class="fa fa-arrow-left cursorPointer"
                          onClick={() => this.EditCancel1()}
                        ></i>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </>
                  ) : (
                    <>
                      {this.state.isView ? (
                        <td className="" width="10%">
                          <i
                            class="fa fa-arrow-left cursorPointer"
                            onClick={this.ViewCancel}
                          ></i>
                        </td>
                      ) : (
                        <td className="border-right text-center">
                          <i
                            class="fa fa-arrow-left cursorPointer"
                            data-target="#cancelpopup"
                            data-toggle="modal"
                            onClick={() => this.EditCancel1()}
                          ></i>
                        </td>
                      )}
                      {this.state.isView ? (
                        <></>
                      ) : (
                        <td className="border-right text-center">
                          <span
                            className={classes.button}
                            onClick={this.EditSave}
                            style={{ minWidth: "60px" }}
                          >
                            <img src={Save} style={{ marginTop: "-4px" }}></img>
                            &nbsp;Save
                          </span>{" "}
                        </td>
                      )}
                      {this.state.isView ? (
                        <></>
                      ) : (
                        <td className="border-right text-center">
                          <span
                            className={`${classes.button} `}
                            style={{ minWidth: "70px" }}
                            onClick={() => this.EditCancel1()}
                          >
                            <img
                              src={Cancel}
                              style={{ marginTop: "-4px" }}
                            ></img>
                            &nbsp;Cancel
                          </span>
                        </td>
                      )}

                      {this.state.isView ? (
                        <></>
                      ) : (
                        <td className="border-right text-center">
                          <span
                            className={`${classes.button}`}
                            style={{ minWidth: "70px" }}
                            data-target="#deletepopup"
                            data-toggle="modal"
                          >
                            <img
                              src={Delete}
                              style={{ marginTop: "-4px" }}
                            ></img>
                            &nbsp;Delete
                          </span>{" "}
                        </td>
                      )}
                    </>
                  )}
                </tr>
              </tbody>
            </table>
          ) : (
            <table className="dataTable" width="100%">
              <tbody>
                <tr>
                  <td width="5%" className="border-right text-center">
                    {this.state.isView ? (
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.ViewCancel}
                      ></i>
                    ) : (
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={() => this.EditCancel1()}
                      ></i>
                    )}
                  </td>
                  <td width="95%">
                    {this.state.value == 1 ? (
                      <></>
                    ) : (
                      <>
                        {this.state.isView ? (
                          <></>
                        ) : (
                          <button
                            className={classes.button}
                            onClick={this.EditSave}
                          >
                            <img src={Save} style={{ marginTop: "-4px" }}></img>
                            &nbsp;Save
                          </button>
                        )}
                        {/* {this.state.isView ?
                                            <button className={classes.button}><img src={download}></img>&nbsp;Download</button> : <></>} */}
                        {this.state.isView ? (
                          <></>
                        ) : (
                          <button
                            className={`${classes.button} pl-3`}
                            onClick={() => this.EditCancel1()}
                          >
                            <img
                              src={Cancel}
                              style={{ marginTop: "-4px" }}
                            ></img>
                            &nbsp;Cancel
                          </button>
                        )}
                        {this.state.isView ? (
                          <></>
                        ) : (
                          <button
                            className={`${classes.button} pl-3`}
                            data-target="#deletepopup"
                            data-toggle="modal"
                          >
                            <img
                              src={Delete}
                              style={{ marginTop: "-4px" }}
                            ></img>
                            &nbsp;Delete
                          </button>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
            {this.state.isMobile ? (
              <></>
            ) : (
              <h6 className="col-12 mt-3 ml-2">
                {this.state.isView
                  ? "Daily Work Progress"
                  : " Edit Work Progress"}
              </h6>
            )}
            <div className="row">
              <div>
                {this.state.isView ? (
                  <></>
                ) : (
                  <>
                    <AppBar
                      position="static"
                      color="inherit"
                      className={classes.root}
                    >
                      <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        classes={{ indicator: classes.indicator }}
                      >
                        <Tab
                          label="Details"
                          className="px-1 ml-4"
                          style={{ textTransform: "none", minWidth: "13px" }}
                          {...a11yProps(0)}
                        />
                        <Tab
                          label="History log"
                          style={{ textTransform: "none", minWidth: "13px" }}
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </AppBar>
                  </>
                )}
                <TabPanel value={this.state.value} index={0}>
                  <div
                    className={
                      this.state.isMobile
                        ? this.state.isView
                          ? "row"
                          : "row px-0 mt-n4"
                        : "row px-2 mt-n3"
                    }
                  >
                    {this.state.isView ? (
                      <>
                        <div
                          className={`row mx-0 align-items-center ${
                            this.state.isMobile ? "" : "text-row"
                          }`}
                        >
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                              this.state.isMobile
                                ? "border-left border-right border-top"
                                : "mt-2 col-md-2"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "d-flex mt-2"
                                  : "float-end text-right d-flex"
                              }
                            >
                              Date :
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${
                              this.state.isMobile
                                ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                                : "col-md-4 pt-4 pb-4 "
                            }`}
                          >
                            <TextField
                              type="date"
                              variant="outlined"
                              size="small"
                              fullWidth
                              id="type-date"
                              disabled
                              value={
                                this.state.ViewData.StartDate &&
                                moment(this.state.ViewData.StartDate).format(
                                  "yyyy-MM-DD"
                                )
                              }
                              placeholder={
                                this.state.ViewData.StartDate &&
                                moment(this.state.ViewData.StartDate).format(
                                  this.props.settings.Convention
                                    ? this.props.settings.Convention
                                    : "DD/MM/YYYY"
                                )
                              }
                              InputProps={{
                                className: `border-radius view-color ${classes.inputfieldAlign}`,
                              }}
                            />
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                              this.state.isMobile
                                ? "border-left border-right"
                                : "mt-2 col-md-2"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "d-flex mt-2"
                                  : "text-right float-end d-flex"
                              }
                            >
                              Activities&nbsp;:
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${
                              this.state.isMobile
                                ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                                : "col-md-4 pt-4 pb-4 "
                            }`}
                          >
                            <TextField
                              type="text"
                              variant="outlined"
                              size="small"
                              fullWidth
                              disabled
                              value={this.state.ViewData.Activity}
                              InputProps={{
                                className: `border-radius view-color ${classes.inputfieldAlign}`,
                              }}
                            />
                          </div>
                        </div>
                        {this.state.ViewData.Description && (
                          <div
                            className={`row mx-0 align-items-center ${
                              this.state.isMobile
                                ? ""
                                : "border-left border-right border-bottom"
                            }`}
                          >
                            <div
                              className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                                this.state.isMobile
                                  ? "border-left border-right"
                                  : "mt-2 col-md-2"
                              }`}
                            >
                              <label
                                className={
                                  this.state.isMobile
                                    ? "mt-2"
                                    : "text-right float-end"
                                }
                              >
                                Description&nbsp;:
                              </label>
                            </div>
                            <div
                              className={`col-12 col-sm-12  col-lg-10 col-xl-11   ${
                                this.state.isMobile
                                  ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                                  : "col-md-10 pt-4 pb-4 "
                              }`}
                            >
                              <TextField
                                multiline
                                rows={4}
                                variant="outlined"
                                size="small"
                                disabled
                                fullWidth
                                value={this.state.ViewData.Description}
                                InputProps={{
                                  className: `border-radius view-color ${classes.inputfieldAlign}`,
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {this.state.ViewData.Photos &&
                          this.state.ViewData.Photos.length > 0 && (
                            <div
                              className={`row mx-0  ${
                                this.state.isMobile
                                  ? ""
                                  : "border-left border-right border-bottom"
                              }`}
                            >
                              <div
                                className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                                  this.state.isMobile
                                    ? "border-left border-right"
                                    : "pt-3 col-md-2"
                                }`}
                              >
                                <label
                                  className={
                                    this.state.isMobile
                                      ? "mt-2"
                                      : "mt-2 text-right float-end"
                                  }
                                >
                                  Photos&nbsp;:
                                </label>
                              </div>
                              <div
                                className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-items-center ${
                                  this.state.isMobile
                                    ? "border-left border-right border-bottom"
                                    : "pt-1 col-md-10 "
                                }`}
                              >
                                <div className="row px-1">
                                  {this.state.ViewData.Photos &&
                                    this.state.ViewData.Photos.map((i, ind) => (
                                      <div
                                        className={`col-12 col-sm-4 col-lg-6 col-xl-4 col-md-6 align-items-center  px-1 mt-2 mb-2 ${
                                          window.innerWidth < 410
                                            ? "col-12"
                                            : this.state.isMobile
                                            ? "col-md-4 "
                                            : "col-md-4"
                                        }`}
                                      >
                                        <div className="row d-flex">
                                          <div
                                            className={`${
                                              window.innerWidth < 290
                                                ? ""
                                                : "col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3"
                                            }`}
                                            onClick={() => {
                                              this.openView1(
                                                i.FileUrl,
                                                i.FileName,
                                                ind
                                              );
                                            }}
                                          >
                                            <img
                                              className="cursorPointer"
                                              width={
                                                window.innerWidth < 290
                                                  ? "100%"
                                                  : "257px"
                                              }
                                              src={i.FileUrl}
                                              onClick={() => {
                                                this.openView1(
                                                  i.FileUrl,
                                                  i.FileName,
                                                  ind
                                                );
                                              }}
                                              style={{
                                                height: "201px",
                                                marginTop: "-9px",
                                                objectPosition: "50% 50%",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )}
                      </>
                    ) : (
                      <>
                        <div
                          className={`row mx-0 align-items-center ${
                            this.state.isMobile ? "" : "text-row"
                          }`}
                        >
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${
                              this.state.isMobile
                                ? "border-left border-right border-top col-md-12"
                                : "col-md-2 px-0"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "d-flex mt-2"
                                  : "float-end text-right m-0 d-flex"
                              }
                            >
                              Date&nbsp;:
                              <div className={`${classes.helperText}`}>
                                <div className="MuiFormHelperText-contained">
                                  *
                                </div>
                              </div>
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${
                              this.state.isMobile
                                ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                                : "col-md-4 pt-4 pb-4 "
                            }`}
                          >
                            {this.state.Error.StartDateError ? (
                              <TextField
                                type="date"
                                variant="outlined"
                                size="small"
                                fullWidth
                                error
                                id="type-date"
                                value={
                                  this.state.addData.StartDate &&
                                  moment(this.state.addData.StartDate).format(
                                    "yyyy-MM-DD"
                                  )
                                }
                                placeholder={
                                  this.state.addData.StartDate &&
                                  moment(this.state.addData.StartDate).format(
                                    this.props.settings.Convention
                                      ? this.props.settings.Convention
                                      : "DD/MM/YYYY"
                                  )
                                }
                                onChange={(e) => {
                                  this.handleInputChange(e, "StartDate");
                                }}
                                InputProps={{
                                  className: `border-radius ${classes.inputfieldAlign}`,
                                }}
                                inputProps={{
                                  max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                  min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                }}
                              />
                            ) : (
                              <TextField
                                type="date"
                                variant="outlined"
                                size="small"
                                id="type-date"
                                value={
                                  this.state.addData.StartDate &&
                                  moment(this.state.addData.StartDate).format(
                                    "yyyy-MM-DD"
                                  )
                                }
                                placeholder={
                                  this.state.addData.StartDate &&
                                  moment(this.state.addData.StartDate).format(
                                    this.props.settings.Convention
                                      ? this.props.settings.Convention
                                      : "DD/MM/YYYY"
                                  )
                                }
                                onChange={(e) => {
                                  this.handleInputChange(e, "StartDate");
                                }}
                                fullWidth
                                InputProps={{
                                  className: `border-radius ${classes.inputfieldAlign}`,
                                }}
                                inputProps={{
                                  max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                  min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                }}
                              />
                            )}
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                              this.state.isMobile
                                ? "border-left border-right"
                                : "mt-2 col-md-2 px-0"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "d-flex mt-2"
                                  : "text-right m-0 float-end d-flex"
                              }
                            >
                              Activities&nbsp;:
                              <div className={`${classes.helperText}`}>
                                <div className="MuiFormHelperText-contained">
                                  *
                                </div>
                              </div>
                            </label>{" "}
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${
                              this.state.isMobile
                                ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                                : "col-md-4 pt-4 pb-4 "
                            }`}
                          >
                            <div className="autocomplete-wrappers">
                              {this.state.Error.ActivityError ? (
                                <>
                                  <Autocomplete
                                    contentEditable={true}
                                    value={this.state.addData.Activity}
                                    inputProps={{
                                      placeholder: "Activitiy",
                                    }}
                                    items={this.props.DWPRDESC_LOOKUP ?? []}
                                    getItemValue={(item) => item.Name}
                                    shouldItemRender={this.renderProjectNames.bind(
                                      this
                                    )}
                                    renderMenu={(item) => (
                                      <div className="dropdowns d-block">
                                        {item}
                                      </div>
                                    )}
                                    renderInput={(props) => {
                                      return (
                                        <input
                                          className="form-control border-radius"
                                          id="exampleFormControlInput1"
                                          {...props}
                                          fullWidth
                                          style={{
                                            width: "100%",
                                            height: 35,
                                            fontSize: 12,
                                            color: "#000000",
                                            borderColor: "red",
                                          }}
                                        />
                                      );
                                    }}
                                    renderItem={(item, isHighlighted) => (
                                      <div
                                        className={`items 
                                                                               ${
                                                                                 isHighlighted
                                                                                   ? "selected-items"
                                                                                   : ""
                                                                               }`}
                                      >
                                        {item.Name}
                                      </div>
                                    )}
                                    onChange={(e) =>
                                      this.handleProjectNameSearchChange(e)
                                    }
                                    onSelect={(e) =>
                                      this.handleProjectNameSelectChange(e)
                                    }
                                  />
                                </>
                              ) : (
                                <Autocomplete
                                  contentEditable={true}
                                  value={this.state.addData.Activity}
                                  inputProps={{
                                    placeholder: "Activity",
                                  }}
                                  items={this.props.DWPRDESC_LOOKUP ?? []}
                                  getItemValue={(item) => item.Name}
                                  shouldItemRender={this.renderProjectNames.bind(
                                    this
                                  )}
                                  renderMenu={(item) => (
                                    <div className="dropdowns d-block">
                                      {item}
                                    </div>
                                  )}
                                  renderInput={(props) => {
                                    return (
                                      <input
                                        className="form-control border-radius"
                                        id="exampleFormControlInput1"
                                        {...props}
                                        // fullWidth
                                        style={{
                                          width: "100%",
                                          height: 35,
                                          fontSize: 12,
                                          color: "#000000",
                                        }}
                                        // style={{ width: this.state.isMobile ? 100 : 223, height: 32, fontSize: 12, color: "#000000" }}
                                      />
                                    );
                                  }}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      className={`items 
                                                                            ${
                                                                              isHighlighted
                                                                                ? "selected-items"
                                                                                : ""
                                                                            }`}
                                    >
                                      {item.Name}
                                    </div>
                                  )}
                                  onChange={(e) =>
                                    this.handleProjectNameSearchChange(e)
                                  }
                                  onSelect={(e) =>
                                    this.handleProjectNameSelectChange(e)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className={`row mx-0 align-items-center ${
                            this.state.isMobile
                              ? ""
                              : "border-left border-right border-bottom"
                          }`}
                        >
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                              this.state.isMobile
                                ? "border-left border-right"
                                : "mt-n3 col-md-2"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "mt-2"
                                  : "float-end text-right "
                              }
                            >
                              Description&nbsp;:
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-10 col-xl-11   ${
                              this.state.isMobile
                                ? "border-left border-right border-bottom col-md-12 pt-1"
                                : "col-md-10 pt-4"
                            }`}
                          >
                            <TextField
                              multiline
                              rows={4}
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={this.state.addData.Description}
                              onChange={(e) =>
                                this.handleInputChange(e, "Description")
                              }
                              InputProps={{
                                className: `border-radius ${classes.inputfieldAlign}`,
                              }}
                            />
                            <label
                              className="float-end pt-2"
                              style={{ opacity: "0.5" }}
                            >
                              {this.state.addData?.Description?.length ==
                              undefined
                                ? 500 - 0
                                : 500 - this.state.addData?.Description?.length}
                              /500 Characters left
                            </label>
                          </div>
                        </div>
                        <div
                          className={`row mx-0 ${
                            this.state.isMobile
                              ? ""
                              : "border-left border-right border-bottom"
                          }`}
                        >
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                              this.state.isMobile
                                ? "border-left border-right"
                                : "mt-3 pt-3 col-md-2"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "mt-2"
                                  : "float-end text-right"
                              }
                            >
                              Photos&nbsp;:
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${
                              this.state.isMobile
                                ? "border-left border-right col-md-12 pt-1 pb-3"
                                : "col-md-4 pt-4 pb-4 "
                            }`}
                          >
                            <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              disabled
                              accept=".png,.jpg"
                              onChange={(e) => this.UploadFile(e)}
                              placeholder="Browse File"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment className="mr-0">
                                    <IconButton
                                      className="rotate p-0"
                                      onClick={this.AttachFiles}
                                    >
                                      <AttachFileIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                className: `border-radius ${classes.inputfieldAlign}`,
                              }}
                            />
                            <input
                              type="file"
                              hidden
                              multiple="multiple"
                              accept=".png,.jpg"
                              onChange={(e) => this.UploadFile(e)}
                              ref={this.inputFile}
                            />
                          </div>
                          <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                          <div className="row mx-0 px-0">
                            <div
                              className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${
                                this.state.isMobile
                                  ? "border-left border-right border-bottom col-md-12"
                                  : "mt-2"
                              }`}
                            >
                              <div
                                className={
                                  this.state.isMobile
                                    ? "row pl-2 pr-3"
                                    : "row px-1"
                                }
                              >
                                {this.state.Docs &&
                                  this.state.Docs.map((i, ind) => {
                                    return (
                                      <div
                                        className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${
                                          window.innerWidth < 410
                                            ? "col-12"
                                            : this.state.isMobile
                                            ? "col-md-4 "
                                            : "col-md-6"
                                        }`}
                                      >
                                        <div className="row d-flex">
                                          <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                          <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3">
                                            <img
                                              src={Delete}
                                              className="cursorPointer"
                                              onClick={() => {
                                                this.OpenPopup(
                                                  i.FileName,
                                                  i.AwsUniqueFileName,
                                                  i.Id,
                                                  ind
                                                );
                                              }}
                                            />
                                          </div>
                                          <div
                                            className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2"
                                            onClick={() => {
                                              this.openView(
                                                i.FileUrl,
                                                i.FileName,
                                                ind
                                              );
                                            }}
                                          >
                                            <img
                                              src={i.FileUrl}
                                              className="cursorPointer"
                                              width={
                                                window.innerWidth < 290
                                                  ? "100%"
                                                  : "257px"
                                              }
                                              onClick={() => {
                                                this.openView(
                                                  i.FileUrl,
                                                  i.FileName,
                                                  ind
                                                );
                                              }}
                                              style={{
                                                height: "201px",
                                                marginTop: "-9px",
                                                objectPosition: "50% 50%",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`row mx-0 align-items-center ${
                            this.state.isMobile
                              ? ""
                              : "border-left border-right border-bottom"
                          }`}
                        >
                          <div
                            className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${
                              this.state.isMobile
                                ? "border-left border-right"
                                : "mt-n4 col-md-2"
                            }`}
                          >
                            <label
                              className={
                                this.state.isMobile
                                  ? "mt-2"
                                  : "float-end text-right m-0"
                              }
                            >
                              Comments&nbsp;:
                            </label>
                          </div>
                          <div
                            className={`col-12 col-sm-12  col-lg-10 col-xl-11   ${
                              this.state.isMobile
                                ? "border-left border-right border-bottom col-md-12 pt-1"
                                : "col-md-10 pt-4"
                            }`}
                          >
                            <TextField
                              multiline
                              rows={8}
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={this.state.addData.Comments}
                              onChange={(e) => {
                                this.handleInputChange(e, "Comments");
                              }}
                              InputProps={{
                                className: `border-radius ${classes.inputfieldAlign}`,
                              }}
                            />
                            <label
                              className="float-end pt-2"
                              style={{ opacity: "0.5" }}
                            >
                              {this.state.addData?.Comments?.length == undefined
                                ? 1000 - 0
                                : 1000 - this.state.addData?.Comments?.length}
                              /1000 Characters left
                            </label>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </TabPanel>
                <TabPanel value={this.state.value} index={1}>
                  <div className="row mt-n3">
                    <div className="col-sm-12 col-12">
                      <div
                        className="table-responsive mb-5"
                        style={{ width: "100%" }}
                      >
                        <table className="table">
                          <thead>
                            <tr className="">
                              <th
                                className="border-top border-right border-left"
                                style={{ width: "15%", minWidth: "170px" }}
                              >
                                <span
                                  className="spandoc-thead"
                                  style={{ color: "#000000" }}
                                >
                                  Timestamp
                                </span>
                              </th>
                              <th
                                className="border-top border-right"
                                style={{
                                  width: "6%",
                                  minWidth:
                                    window.innerWidth < 1000 ? "80px" : "",
                                }}
                              >
                                <span
                                  className="spandoc-thead"
                                  style={{ color: "#000000" }}
                                >
                                  Action
                                </span>
                              </th>
                              <th
                                className="border-top border-right"
                                style={{
                                  width: "15%",
                                  minWidth:
                                    window.innerWidth < 1000 ? "135px" : "",
                                }}
                              >
                                <span
                                  className="spandoc-thead"
                                  style={{
                                    color: "#000000",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Action by
                                </span>
                              </th>
                              <th
                                className="border-top border-right"
                                style={{
                                  width: "64%",
                                  minWidth:
                                    window.innerWidth < 1000 ? "400px" : "",
                                }}
                              >
                                <span
                                  className="spandoc-thead"
                                  style={{ color: "#000000" }}
                                >
                                  Comments
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ fontFamily: "Segoe UI" }}>
                            {this.props.historyLog &&
                              this.props.historyLog.map((i) => (
                                <tr>
                                  <td className="spandoc-td border-right border-left align-middle">
                                    {moment(i.TimeStamp).format(
                                      this.props.settings.Convention
                                        ? this.props.settings.Convention +
                                            " hh:mm:ss A"
                                        : "DD/MM/YYYY hh:mm:ss A"
                                    )}
                                  </td>
                                  <td className="spandoc-td border-right align-middle">
                                    {i.Action}
                                  </td>
                                  <td className="spandoc-td border-right align-middle">
                                    {i.ActionBy}
                                  </td>
                                  <td className="spandoc-td border-right align-middle">
                                    {i.Comments}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </div>
            </div>
          </div>
          <div
            class="modal fade p-5 mt-5"
            id="deletepopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">Are you sure you want to delete?</h5>
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#00838F", border: "none" }}
                    onClick={this.DeleteItem}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    id="closemodal1"
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade p-5 mt-5"
            id="cancelpopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">
                      The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#00838F", border: "none" }}
                    onClick={this.EditCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade p-5 mt-5"
            id="deletepopup1"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile
                ? "2%"
                : this.props.menuToggle
                ? "10%"
                : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">Are you sure you want to delete?</h5>{" "}
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#00838F", border: "none" }}
                    onClick={() => this.DeleteItemfile()}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal2"
                    onClick={() => {
                      window.$("#deletepopup1").modal("hide");
                    }}
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade "
            id="viewscreen"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: this.state.isMobile ? "25%" : "13%",
              left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "",
              overflowY: "scroll",
              height: "90vh",
            }}
          >
            <div class="modal-dialog modal-lg " role="document">
              <div class="modal-content ">
                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                  <div className="row">
                    <div className="col-12 ">
                      <div
                        className="cursorPointer float-end mr-3"
                        id="viewscreen"
                        onClick={() => {
                          window.$("#viewscreen").modal("hide");
                        }}
                      >
                        <button className={`${classes.button} px-0 hidefield`}>
                          &nbsp;Close
                        </button>
                      </div>
                    </div>
                    <div className="col-12 text-center">
                      <div
                        id="carouselExampleCaptions"
                        class="carousel slide"
                        data-bs-ride="carousel"
                        style={{}}
                      >
                        <div class="carousel-indicators"></div>
                        <div class="carousel-inner">
                          {this.state.Docs &&
                            this.state.Docs.map((i, ind) => (
                              <>
                                <div
                                  class={
                                    ind === this.state.index
                                      ? "carousel-item active col-12 text-center align-middle"
                                      : " align-middle carousel-item col-12 text-center"
                                  }
                                >
                                  <div>
                                    <InnerImageZoom
                                      moveType="drag"
                                      zoomScale={2}
                                      hideCloseButton={true}
                                      src={i.FileUrl}
                                      hasSpacer={true}
                                      afterZoomIn={() => {
                                        $("#viewscreen > div > div ").addClass(
                                          "Transparent"
                                        );
                                        $(".hidefield").removeClass("d-block");
                                        $(".hidefield").addClass("d-none");
                                      }}
                                      afterZoomOut={() => {
                                        $(
                                          "#viewscreen > div > div"
                                        ).removeClass("Transparent");
                                        $(".hidefield").addClass("d-block");
                                        $(".hidefield").removeClass("d-none");
                                      }}
                                    />
                                  </div>
                                  {this.state.Docs.length <= 1 ? (
                                    ""
                                  ) : (
                                    <>
                                      <button
                                        class="carousel-control-prev my-5 hidefield"
                                        type="button"
                                        data-bs-target="#carouselExampleCaptions"
                                        onClick={() => this.preView(ind - 1)}
                                        data-bs-slide="prev"
                                      >
                                        <span
                                          class="carousel-control-prev-icon black"
                                          aria-hidden="true"
                                        ></span>
                                        <span class="visually-hidden">
                                          Previous
                                        </span>
                                      </button>
                                      <button
                                        class="carousel-control-next  my-5 hidefield"
                                        type="button"
                                        data-bs-target="#carouselExampleCaptions"
                                        onClick={() => this.nextView(ind + 1)}
                                        data-bs-slide="next"
                                      >
                                        <span
                                          class="carousel-control-next-icon"
                                          aria-hidden="true"
                                        ></span>
                                        <span class="visually-hidden">
                                          Next
                                        </span>
                                      </button>
                                    </>
                                  )}
                                </div>
                              </>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade "
            id="viewscreen1"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: this.state.isMobile ? "25%" : "13%",
              left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "",
              overflowY: "scroll",
              height: "90vh",
            }}
          >
            <div class="modal-dialog modal-lg " role="document">
              <div class="modal-content ">
                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                  <div className="row">
                    <div className="col-12 ">
                      <div
                        className="cursorPointer float-end mr-3"
                        id="viewscreen1"
                        onClick={() => {
                          window.$("#viewscreen1").modal("hide");
                        }}
                      >
                        <button className={`${classes.button} px-0 hidefield`}>
                          &nbsp;Close
                        </button>
                      </div>
                    </div>
                    <div className="col-12 text-center">
                      <div
                        id="carouselExampleCaptions"
                        class="carousel slide"
                        data-bs-ride="carousel"
                        style={{}}
                      >
                        <div class="carousel-indicators"></div>

                        <div class="carousel-inner">
                          {this.state.ViewData.Photos &&
                            this.state.ViewData.Photos.map((i, ind) => (
                              <>
                                <div
                                  class={
                                    ind === this.state.index
                                      ? "carousel-item active col-12 text-center align-middle"
                                      : " align-middle carousel-item col-12 text-center"
                                  }
                                >
                                  <div>
                                    <InnerImageZoom
                                      moveType="drag"
                                      zoomScale={2}
                                      hideCloseButton={true}
                                      src={i.FileUrl}
                                      hasSpacer={true}
                                      afterZoomIn={() => {
                                        $("#viewscreen1 > div > div ").addClass(
                                          "Transparent"
                                        );
                                        $(".hidefield").removeClass("d-block");
                                        $(".hidefield").addClass("d-none");
                                      }}
                                      afterZoomOut={() => {
                                        $(
                                          "#viewscreen1 > div > div "
                                        ).removeClass("Transparent");
                                        $(".hidefield").addClass("d-block");
                                        $(".hidefield").removeClass("d-none");
                                      }}
                                    />
                                  </div>
                                  {this.state.ViewData.Photos.length <= 1 ? (
                                    ""
                                  ) : (
                                    <>
                                      <button
                                        class="carousel-control-prev my-5 hidefield"
                                        type="button"
                                        data-bs-target="#carouselExampleCaptions"
                                        onClick={() => this.preView(ind - 1)}
                                        data-bs-slide="prev"
                                      >
                                        <span
                                          class="carousel-control-prev-icon black"
                                          aria-hidden="true"
                                        ></span>
                                        <span class="visually-hidden">
                                          Previous
                                        </span>
                                      </button>
                                      <button
                                        class="carousel-control-next  my-5 hidefield"
                                        type="button"
                                        data-bs-target="#carouselExampleCaptions"
                                        onClick={() => this.nextView(ind + 1)}
                                        data-bs-slide="next"
                                      >
                                        <span
                                          class="carousel-control-next-icon"
                                          aria-hidden="true"
                                        ></span>
                                        <span class="visually-hidden">
                                          Next
                                        </span>
                                      </button>
                                    </>
                                  )}
                                </div>
                              </>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade p-5 mt-5"
          id="cancelpopup1"
          tabindex="-1"
          role="dialog"
          aria-labelledby="cancelpopupLabel"
          aria-hidden="true"
          style={{
            top: "13%",
            left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
          }}
        >
          <div class="modal-dialog" role="document">
            <div
              class={
                this.state.isMobile ? "modal-content" : "modal-content p-3"
              }
            >
              <div class="modal-body pb-0">
                <h1 className="text-center">
                  <img src={del}></img>
                </h1>
                <div className="text-center">
                  <h5 class="fw-bold">
                    The data will be lost. Do you really want to cancel?
                  </h5>{" "}
                </div>
              </div>
              <div class="modal-footer border-top-0 m-auto">
                <button
                  type="button"
                  class={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  data-dismiss="modal"
                  style={{ backgroundColor: "#00838F", border: "none" }}
                  onClick={this.SideBarCancel}
                >
                  <span className="">Yes</span>
                </button>
                <button
                  type="button"
                  id="closemodal1"
                  class={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  onClick={() => window.$("#cancelpopup1").modal("hide")}
                  style={{
                    backgroundColor: "#EBEBEB",
                    border: "none",
                    color: "#111010",
                  }}
                >
                  <span className="">No</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    DWPRDESC_LOOKUP: state.MasterDataReducer.Lookup_data || [],
    settings: state.commonReducer.settings || [],
    historyLog: state.commonReducer.historyLog || [],
  };
}

EditDWPR.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDWPR))
);
